export const COUNTRIES = {
  IN: {
    name: 'India',
    currency: 'INR',
    symbol: '₹',
    locale: 'en-IN',
    bankPlaceholder: 'UPI: yourname@oksbi\nBank: HDFC Bank\nAccount: 1234567890\nIFSC: HDFC0001234\nBranch: Jubilee Hills',
    phonePlaceholder: '+91 98765 43210',
    addressPlaceholder: 'Plot 42, Jubilee Hills, Hyderabad - 500033, Telangana',
    taxLabel: 'GST Number',
    taxPlaceholder: '22AAAAA0000A1Z5',
    invoiceTaxLabel: 'GSTIN',
    totalsTaxLabel: 'GST',
    showGstSlab: true,
  },
  US: {
    name: 'United States',
    currency: 'USD',
    symbol: '$',
    locale: 'en-US',
    bankPlaceholder: 'PayPal: paypal.me/yourname\nBank: Chase Bank\nAccount: 123456789\nRouting: 021000021',
    phonePlaceholder: '+1 555 123 4567',
    addressPlaceholder: '123 Main Street, New York, NY 10001',
    taxLabel: 'EIN / Tax ID',
    taxPlaceholder: '12-3456789',
    invoiceTaxLabel: 'EIN',
    totalsTaxLabel: 'Tax',
    showGstSlab: false,
  },
  GB: {
    name: 'United Kingdom',
    currency: 'GBP',
    symbol: '£',
    locale: 'en-GB',
    bankPlaceholder: 'PayPal: paypal.me/yourname\nBank: Barclays\nAccount: 12345678\nSort Code: 20-00-00',
    phonePlaceholder: '+44 7700 900123',
    addressPlaceholder: '10 Downing Street, London SW1A 2AA',
    taxLabel: 'VAT Number',
    taxPlaceholder: 'GB123456789',
    invoiceTaxLabel: 'VAT No',
    totalsTaxLabel: 'VAT',
    showGstSlab: false,
  },
  AE: {
    name: 'UAE',
    currency: 'AED',
    symbol: 'د.إ',
    locale: 'en-AE',
    bankPlaceholder: 'Bank: Emirates NBD\nIBAN: AE070331234567890123456\nSWIFT: EBILAEAD',
    phonePlaceholder: '+971 50 123 4567',
    addressPlaceholder: 'Office 101, Business Bay, Dubai',
    taxLabel: 'TRN Number',
    taxPlaceholder: '100123456700003',
    invoiceTaxLabel: 'TRN',
    totalsTaxLabel: 'Tax',
    showGstSlab: false,
  },
  AU: {
    name: 'Australia',
    currency: 'AUD',
    symbol: 'A$',
    locale: 'en-AU',
    bankPlaceholder: 'PayPal: paypal.me/yourname\nBank: Commonwealth Bank\nAccount: 12345678\nBSB: 062-000',
    phonePlaceholder: '+61 4xx xxx xxx',
    addressPlaceholder: '42 George Street, Sydney NSW 2000',
    taxLabel: 'ABN',
    taxPlaceholder: '51 824 753 556',
    invoiceTaxLabel: 'ABN',
    totalsTaxLabel: 'GST',
    showGstSlab: false,
  },
  CA: {
    name: 'Canada',
    currency: 'CAD',
    symbol: 'CA$',
    locale: 'en-CA',
    bankPlaceholder: 'Bank: RBC Royal Bank\nAccount: 12345678901\nTransit: 00112-003',
    phonePlaceholder: '+1 555 123 4567',
    addressPlaceholder: '123 Main Street, Toronto, ON M5H 2N2',
    taxLabel: 'Business Number',
    taxPlaceholder: '123456789RT0001',
    invoiceTaxLabel: 'Tax ID',
    totalsTaxLabel: 'Tax',
    showGstSlab: false,
  },
  SG: {
    name: 'Singapore',
    currency: 'SGD',
    symbol: 'S$',
    locale: 'en-SG',
    bankPlaceholder: 'Bank: DBS Bank\nAccount: 012-3456789-0\nSWIFT: DBSSSGSG',
    phonePlaceholder: '+65 8123 4567',
    addressPlaceholder: '1 Marina Boulevard, Singapore 018989',
    taxLabel: 'GST Registration Number',
    taxPlaceholder: '200312345A',
    invoiceTaxLabel: 'Tax ID',
    totalsTaxLabel: 'GST',
    showGstSlab: false,
  },
  NZ: {
    name: 'New Zealand',
    currency: 'NZD',
    symbol: 'NZ$',
    locale: 'en-NZ',
    bankPlaceholder: 'Bank: ANZ New Zealand\nAccount: 01-0123-0123456-00',
    phonePlaceholder: '+64 21 123 4567',
    addressPlaceholder: '1 Queen Street, Auckland 1010',
    taxLabel: 'GST / IRD Number',
    taxPlaceholder: '123-456-789',
    invoiceTaxLabel: 'Tax ID',
    totalsTaxLabel: 'GST',
    showGstSlab: false,
  },
  EU: {
    name: 'Europe (EUR)',
    currency: 'EUR',
    symbol: '€',
    locale: 'en-DE',
    bankPlaceholder: 'Bank: Deutsche Bank\nIBAN: DE89 3704 0044 0532 0130 00\nBIC/SWIFT: DEUTDEDB',
    phonePlaceholder: '+49 151 12345678',
    addressPlaceholder: 'Friedrichstraße 1, 10117 Berlin',
    taxLabel: 'VAT Number',
    taxPlaceholder: 'DE123456789',
    invoiceTaxLabel: 'VAT No',
    totalsTaxLabel: 'VAT',
    showGstSlab: false,
  },
  ZA: {
    name: 'South Africa',
    currency: 'ZAR',
    symbol: 'R',
    locale: 'en-ZA',
    bankPlaceholder: 'Bank: Standard Bank\nAccount: 123456789\nBranch Code: 051001',
    phonePlaceholder: '+27 71 123 4567',
    addressPlaceholder: '1 Sandton Drive, Sandton, 2196',
    taxLabel: 'VAT Number',
    taxPlaceholder: '4123456789',
    invoiceTaxLabel: 'VAT No',
    totalsTaxLabel: 'VAT',
    showGstSlab: false,
  },
};

export const getCountryConfig = (code) => COUNTRIES[code] || COUNTRIES['IN'];
